import { render, staticRenderFns } from "./qrCode2.vue?vue&type=template&id=2965fd14&scoped=true&"
import script from "./qrCode2.vue?vue&type=script&lang=ts&"
export * from "./qrCode2.vue?vue&type=script&lang=ts&"
import style0 from "./qrCode2.vue?vue&type=style&index=0&id=2965fd14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965fd14",
  null
  
)

export default component.exports